/**
 * DeleteMassnahmeDialog — Bestätigung zum Löschen einer Maßnahme.
 * Zeigt eine Warnung, falls noch Einsätze verknüpft sind, und erlaubt
 * das „Trotzdem löschen".
 */
import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../../components/ui/alert-dialog';
import { AlertTriangle, Loader2, Trash2 } from 'lucide-react';

export const DeleteMassnahmeDialog = ({ state, onConfirm, onCancel }) => {
  const { open, massnahme, shiftsCount, deleting } = state || {};
  if (!massnahme) return null;
  const hasShifts = shiftsCount > 0;

  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o && !deleting) onCancel(); }}>
      <AlertDialogContent data-testid="delete-massnahme-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            {hasShifts ? (
              <AlertTriangle className="h-5 w-5 text-amber-500" />
            ) : (
              <Trash2 className="h-5 w-5 text-red-500" />
            )}
            Maßnahme löschen
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm">
              <p>
                Soll die Maßnahme <strong>„{massnahme.name}"</strong>{' '}
                wirklich gelöscht werden?
              </p>
              {hasShifts && (
                <div className="rounded-lg border border-amber-500/40 bg-amber-50 dark:bg-amber-900/10 p-3 space-y-1">
                  <p className="font-medium text-amber-900 dark:text-amber-100">
                    Achtung: {shiftsCount} Einsatz{shiftsCount !== 1 ? 'e' : ''} sind dieser Maßnahme zugeordnet.
                  </p>
                  <p className="text-amber-800 dark:text-amber-200 text-xs">
                    Beim „Trotzdem löschen" werden <strong>alle zugehörigen Einsätze</strong> ebenfalls unwiderruflich gelöscht.
                    Mitarbeitende verlieren dadurch ihre eingeplanten Termine für diese Maßnahme.
                  </p>
                </div>
              )}
              {!hasShifts && (
                <p className="text-muted-foreground text-xs">
                  Diese Maßnahme hat aktuell keine zugehörigen Einsätze und kann sicher gelöscht werden.
                </p>
              )}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleting} data-testid="delete-massnahme-cancel">
            Abbrechen
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => { e.preventDefault(); onConfirm(); }}
            disabled={deleting}
            className={hasShifts
              ? 'bg-red-600 hover:bg-red-700 text-white'
              : 'bg-red-500 hover:bg-red-600 text-white'}
            data-testid="delete-massnahme-confirm"
          >
            {deleting ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Wird gelöscht...
              </>
            ) : hasShifts ? (
              'Trotzdem löschen'
            ) : (
              'Löschen'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
